import { RemoteApiProvider } from '@v2/services/flowsteps/remote-api-provider';
import { ProviderType } from 'shared/types/flowstep';
import { userStore } from 'src/stores';
import { ProviderClient, ProviderFactory } from 'shared/providers/provider';

class FrontendProviderFactory extends ProviderFactory {
  getProviderClient(providerType: ProviderType): ProviderClient {
    if (!userStore.token) {
      throw new Error('No user token provided');
    }

    return new RemoteApiProvider(userStore.token, providerType);
  }
}

export default FrontendProviderFactory;
